import { Component, OnDestroy } from '@angular/core'
import { Store } from '@ngrx/store'
import { selectionActions } from '../../../state/selection/selection.actions'
import { SelectionMode, SelectionType } from '../../../state/selection/selection.state'
import {
    selectSelectionSize,
    selectMode,
    selectSelectionState,
} from '../../../state/selection/selection.selectors'
import { plotDataActions } from 'src/app/state/plot-data/plot-data.actions'
import {
    selectLassoType,
    selectPointOpacity,
    selectPointSize,
} from 'src/app/state/plot-data/plot-data.selectors'
import { Dialog } from '@angular/cdk/dialog'
import { take } from 'rxjs'
import { Subject } from 'rxjs'
import { AddPropertiesDialogComponent } from '../../add-properties-dialog/add-properties-dialog.component'
import { selectCaseSegObjectPropertyMap } from 'src/app/state/case/case.selectors'
import { ToasterService } from 'src/app/shared/services/toaster.service'

@Component({
    selector: 'app-selection-manipulation',
    templateUrl: './selection-manipulation.component.html',
    styleUrls: ['./selection-manipulation.component.scss'],
})
export class SelectionManipulationComponent implements OnDestroy {
    SelectionModeEnum = SelectionMode
    caseSegObjectPropertyMap = this.store.select(selectCaseSegObjectPropertyMap)
    selectionSize$ = this.store.select(selectSelectionSize)
    selectionMode$ = this.store.select(selectMode)
    pointSize$ = this.store.select(selectPointSize)
    pointOpacity$ = this.store.select(selectPointOpacity)
    lassoType$ = this.store.select(selectLassoType)
    isUnsupervisedSelection = false
    resolution$ = 6
    lassoType = 'freeform'

    private readonly destroy$ = new Subject<void>()

    constructor(
        private readonly store: Store,
        private readonly dialog: Dialog,
        private readonly toasterService: ToasterService
    ) {
        this.store
            .select(selectSelectionState)
            .pipe()
            .subscribe(state => {
                if (state.type === SelectionType.Unsupervised) {
                    this.isUnsupervisedSelection = true
                } else {
                    this.isUnsupervisedSelection = false
                }
            })
    }

    ngOnDestroy(): void {
        this.destroy$.next()
        this.destroy$.complete()
    }

    clearSelection(): void {
        this.store.dispatch(selectionActions.clearSelection())
    }

    setSelectionModeAdd(): void {
        this.store.dispatch(selectionActions.setMode({ mode: SelectionMode.Add }))
    }

    setSelectionModeSubtract(): void {
        this.store.dispatch(selectionActions.setMode({ mode: SelectionMode.Subtract }))
    }

    setPointSize(size: number): void {
        this.store.dispatch(plotDataActions.setPointSize({ size }))
    }

    setPointOpacity(opacity: number): void {
        this.store.dispatch(plotDataActions.setPointOpacity({ opacity }))
    }

    setLassoType(): void {
        this.lassoType$.pipe(take(1)).subscribe(lassoType => {
            this.store.dispatch(
                plotDataActions.setLassoType({
                    lassoType: lassoType === 'freeform' ? 'rectangle' : 'freeform',
                })
            )
        })
    }

    setResolution(resolution: number): void {
        this.resolution$ = resolution
        this.store.dispatch(selectionActions.setResolution({ resolution: resolution }))
    }

    openAddPropertiesDialog(): void {
        this.caseSegObjectPropertyMap.pipe(take(1)).subscribe(caseSegObjectPropertyMap => {
            if (!caseSegObjectPropertyMap) {
                this.toasterService.error('Select an intensity map first', 'Error')
                return
            } else {
                this.dialog.open(AddPropertiesDialogComponent)
            }
        })
    }
}
